// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import moment from "moment"

import {
  SvgIcon,
  Table,
  Spinner,
  Warning,
  SpanWithData
} from '../../'

import {
  decodeBase64,
  PageNavigationControl
} from '../../../utils'


const QUERY_BULKMESSAGES = gql`
  query($employerGroupId: UUID!, $employerId: UUID, $audience: ID, $status: String, $createdAtFrom: DateTime, $createdAtTo: DateTime, $scheduledAtFrom: DateTime, $scheduledAtTo: DateTime) {
    bulkmessages(fromEmployergroup_Id: $employerGroupId, fromIdentity_Employer_Id: $employerId, audience: $audience, status: $status, createdAt_Gte: $createdAtFrom, createdAt_Lte: $createdAtTo, scheduledAt_Gte: $scheduledAtFrom, scheduledAt_Lte: $scheduledAtTo) {
      edges {
        node {
          id
          description
          content
          scheduledAt
          createdAt
          status
          audience {
            id
            name
          }
          messages {
            totalCount
            edges {
              node {
                id
                status
              }
            }
          }
          telegrammessages {
            totalCount
            edges {
              node {
                id
                status
              }
            }
          }
        }
      }
    }
  }
`


class EmployerGroupBulkSMSMessages extends PureComponent {
  static propTypes = {
    employerGroupId: PropTypes.string,
    employerId: PropTypes.string,
    status: PropTypes.string,
    audience: PropTypes.string,
    createdAtFrom: PropTypes.string,
    createdAtTo: PropTypes.string,
    scheduledAtFrom: PropTypes.string,
    scheduledAtTo: PropTypes.string,
    orderBy: PropTypes.string,
    changeSort: PropTypes.func,
    resultsPerPage: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    resultsPerPage: 15,
    className: ''
  }

  state = {
    selectedMessage: null,
    replyToMessage: false,
    filterChanged: false,
    pageNav: new PageNavigationControl()
  }

  getTableRows = (messages) => (
    messages.edges.map(({ node: message }) => (
      <tr onClick={() => this.props.history.push(`/group/${this.props.employerGroupId}/communications/bulk/${message.id}`)} key={`row_${message.id}`}>
        <td>
          {message.description}
        </td>
        <td>
          {message.audience.name}
        </td>
        <td>
          <SpanWithData forField='BulkMessageStatus' searchKey={message.status} />
        </td>
        <td>
          {message.scheduledAt
            ? moment(message.scheduledAt).format('lll')
            : '-'
          }
        </td>
        <td>
          {message.messages.totalCount}
        </td>
        <td>
          {message.messages.edges.filter(message => message.node.status === "SENT_AAT").length}
        </td>
        <td>
          {message.telegrammessages.totalCount}
        </td>
        <td>
          {message.telegrammessages.edges.filter(message => message.node.status === "SENT_UPSTREAM").length}
        </td>
      </tr>
    ))
  )

  render() {
    if (this.props.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    // let pageNav = this.state.pageNav
    let columns = ['Description', 'Audience', 'Status', 'Scheduled at', 'SMS', 'SMS sent', 'Telegram', 'Telegram sent']

    // let messages = this.props.messages
    // let startCursor = messages.pageInfo.startCursor
    // let totalCount = messages.totalCount

    const { employerGroupId, employerId, status, audience, createdAtFrom, createdAtTo, scheduledAtFrom, scheduledAtTo, className } = this.props
    return (
      <div className={className}>
        <Query
          query={QUERY_BULKMESSAGES}
          variables={{
            employerGroupId: employerGroupId
              ? decodeBase64(employerGroupId)
              : undefined,
            employerId: employerId
              ? decodeBase64(employerId)
              : undefined,
            status,
            audience,
            createdAtFrom,
            createdAtTo,
            scheduledAtFrom,
            scheduledAtTo
          }}
          // data will be fetched every 60 seconds
          pollInterval={60000}>
          {({ loading, error, data }) => {
            if (loading) {
              return <Spinner type='tail' />
            }

            if (error) {
              return <Warning>Failed to fetch bulk SMS messages</Warning>
            }

            if (data.bulkmessages.edges.length === 0) {
              return (
                <div className='slds-p-around_medium'>
                  <SvgIcon
                    variant='utility'
                    symbol='info'
                    size='small'
                    colour='light'
                    className='slds-m-right_medium'
                  />
                  No bulk messages
                </div>
              )
            }

            return (
              <React.Fragment>
                <Table
                  columns={columns}
                  rows={this.getTableRows(data.bulkmessages)}
                  objectRows={true}
                  orderBy={this.props.orderBy}
                  changeSort={this.props.changeSort}
                  querySortableColumns={{
                    'Date/Time': {
                      orderByName: 'timestamp'
                    }
                  }}
                />
                {/*<PageNavigationButtons
                  onNextClick={() => pageNav.nextPage(this.props.fetchNext)}
                  onPreviousClick={() => pageNav.previousPage(this.props.fetchPrevious)}
                  previousDisabled={pageNav.firstPage}
                  nextDisabled={pageNav.lastPage}
                  startCursor={startCursor}
                  totalCount={totalCount}
                  resultsPerPage={this.props.resultsPerPage}
                  resultsText='messages'
                  onPageNumberClick={pageNumber => this.props.refetch({ cursor: getPageCursor(pageNumber, this.props.resultsPerPage) })}
                  className="slds-p-around_medium slds-float_right"
                />*/}
              </React.Fragment>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default withRouter(EmployerGroupBulkSMSMessages)



// WEBPACK FOOTER //
// ./src/components/messageplus/employergroup-bulk-sms-messages/index.js